export default __webpack_public_path__ + "static/media/ld-1.3f42f629.jpg";